import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import constants from '../../constants';
import Icon from '../Icon';
import styles from './styles.scss';

export default class Alert extends Component {
  static propTypes = {
    type: PropTypes.oneOf([
      constants.alerts.success,
      constants.alerts.info,
      constants.alerts.warning,
      constants.alerts.danger,
      constants.alerts.bell,
    ]).isRequired,
    showIcon: PropTypes.bool,
    showDefault: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
    cta: PropTypes.node,
  };

  static defaultProps = {
    id: '',
    className: '',
    showIcon: true,
    showDefault: false,
  };

  showAlertIcon(iconType) {
    const { showIcon, type } = this.props;

    if (!iconType) {
      return showIcon;
    }

    return type === iconType;
  }

  getIconForType(type) {
    const {
      alerts: { success, info, warning, danger, bell },
    } = constants;

    const iconByType = {
      [success]: 'notification-success',
      [info]: 'notification-info',
      [warning]: 'notification-warning',
      [danger]: 'notification-error',
      [bell]: 'alarm',
    };

    return iconByType[type];
  }

  render() {
    const { id, type, children, className, showDefault, cta, fullWidth } = this.props;

    const {
      alerts: { success, info, warning, danger, bell },
    } = constants;

    return showDefault ? (
      <div
        id={id}
        className={classNames(className, styles.defaultAlert, styles[`alert-${type}`])}
        data-testid="defaultAlert"
        role="alert"
      >
        <div className={styles.icon}>
          <Icon round={false} icon={this.getIconForType(type)} />
        </div>
        <div
          className={classNames(styles.body, {
            [styles.fullWidth]: fullWidth,
          })}
        >
          <div className={styles.content}>{children}</div>
          {!!cta && <div className={styles.cta}>{cta}</div>}
        </div>
      </div>
    ) : (
      <div
        id={id}
        role="alert"
        className={classNames(
          className,
          styles.alertContainer,
          styles.alert,
          styles[`alert-${type}`],
          {
            [styles.alertIcon]: this.showAlertIcon(),
            [styles.alertSuccess]: this.showAlertIcon(success),
            [styles.alertInfo]: this.showAlertIcon(info),
            [styles.alertWarning]: this.showAlertIcon(warning),
            [styles.alertDanger]: this.showAlertIcon(danger),
            [styles.alertBell]: this.showAlertIcon(bell),
          },
        )}
      >
        <div className={styles.alertBody}>{children}</div>
      </div>
    );
  }
}
